import QuestionGeneratorHelper from '../core/question_generator_helper.js'

const handlers = {
    javascript: 'addJSCode',
    python:     'addPythonCode'
}


QuestionGeneratorHelper.prototype.addCode = function (sources, language) {
    const jsSource = sources.javascript || sources
    const source   = sources[language]  || jsSource
    const handler  = (handlers[language]) ? handlers[language] : handlers.javascript

    if (typeof this.answer === 'undefined') {
        this.answer = eval(jsSource) //eslint-disable-line no-eval
    }
    this[handler](source)
}


QuestionGeneratorHelper.prototype.codeArrayToDisplay = function (array) {
    return '[' + array.map(v => (typeof v === 'string' ? "'" + v + "'" : v)).join(', ') + ']'
}




